import type { IExcelAddInEnvironment } from "./environment.interface";

// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

//rollout to dev
export const environment: IExcelAddInEnvironment = {
  production: false,
  graphqlURI: "https://backend-prodsim.ankaadia.com/api/graphql",
  wsURI: "wss://backend-prodsim.ankaadia.com/api/subscriptions",
  auth0_clientId: "fJJMdwkpdhNfzJ1bvoJz2p7PbGEUd2ZQ",
  auth0_domain: "ankaadia-production-simulation.eu.auth0.com",
  auth0_issuer: "ankaadia-production-simulation.eu.auth0.com",
  auth0_audience: "https://production-simulation.ankaadia.com/api",
  appinsights_connectionstring:
    "InstrumentationKey=1d13da41-e94b-476b-b6a5-a0c4f29a0965;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/",
  loginUrl: "https://localhost:3005/assets/loginPage.html",
  redirectUrl: "https://localhost:3005/assets/popupRedirect.html",
  logoutUrl: "https://localhost:3005/assets/logoutPage.html",
  applicationName: "ExcelAdd-In",
  emailEditorURI: null,
  facebookAppId: null,
  facebookPageId: null,
  recaptchaSiteKey: null,
  useServiceWorker: false,
  cometChatAppId: undefined,
  cometChatRegion: undefined,
  cometChatFcmProviderId: undefined,
  firebaseConfig: undefined,
};
